export default __webpack_public_path__ + "static/media/selected-hcp-legend-icon-new.aba731d0.svg";